/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M67.5 8h-35A10.5 10.5 0 0022 18.5v62.762a10.5 10.5 0 0010.5 10.5h35a10.5 10.5 0 0010.5-10.5V18.5A10.5 10.5 0 0067.5 8zM50 86.512a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm21-15.75a3.5 3.5 0 01-3.5 3.5h-35a3.5 3.5 0 01-3.5-3.5V20.25a3.5 3.5 0 013.5-3.5h35a3.5 3.5 0 013.5 3.5v50.512z"
    ></path>
  </Svg>
)

export default Icon
